// src/services/api.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://riskassessplus.com/api';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add request interceptor for authentication
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
            console.log("Using token:", token); // Debug log
        } else {
            console.warn("No token found in localStorage"); // Debug log
        }
        return config;
    },
    (error) => Promise.reject(error)
);


// Add response interceptor for error handling
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        // Handle token expiration — clear auth and redirect to login
        if (error.response?.status === 401) {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('user');
            // Only redirect if not already on login page
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }

        return Promise.reject(error);
    }
);

// For development/demo purposes
// This helps simulate API calls when no backend is available
api.interceptors.request.use(
    async (config) => {
        // Only in development environment
        if (process.env.NODE_ENV === 'development') {
            const mockResponses = {
                // Add mock responses here as needed
            };

            // Check if this request should be mocked
            const mockKey = `${config.method}:${config.url}`;
            if (mockResponses[mockKey]) {
                // Stop the request and return mock data
                throw {
                    config,
                    response: {
                        status: 200,
                        data: mockResponses[mockKey]()
                    }
                };
            }
        }
        return config;
    }
);

export default api;